// src/App.js
import './App.css';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { ThemeProvider } from "@mui/material/styles";
import Theme from "./themes/theme";
import { PatientProvider } from './context/PatientContext/PatientContext';
import { AuthProvider } from './context/AuthContext/AuthContext';
import { CarePlanProvider } from './context/CarePlanContext/CarePlanContext';
import { PatientAssignmentProvider } from './context/PatientContext/PatientAssignmentContext';
import { LocationProvider } from './context/MasterContext/LocationContext';
import { ObservationProvider } from './context/ObservationContext/ObservationContext';
import { PatientMapProvider } from './context/PatientContext/PatientMapContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { IACarePlanProvider } from './context/IACarePlanContext/IACarePlanContext';
import { CareGapProvider } from './context/PatientContext/CareGapContext/CareGapContext';
import { WelcomeCampaignProvider } from './context/PatientContext/WelcomeCampaignContext/WelcomeCampaignContext';


import AppRouter from './AppRouter';
import { PCPChangesProvider } from './context/PatientContext/PCPChangesContext/PCPChangesContext';
import { NoRecentVisitProvider } from './context/PatientContext/NoRecentVisitContext/NoRecentVisitContext';
import { CodingOpportunitiesProvider } from './context/PatientContext/CodingOpportunities/CodingOpportunities';
import { AdvancedMdProvider } from "./context/AdvancedMD/AdvancedMdContext";
import { CodingOpProvider } from './context/CodingOpContext/CodingOpContext';
import { InfoPat2Provider } from './context/InfoPat2Context/InfoPat2Context';
import SessionManager from './components/Structure/SessionManager';
import { DebugProvider } from './context/DebugContext';
import DebugAxiosInterceptor from './components/Structure/DebugAxiosInterceptor';
import { PermissionsProvider } from './context/PermissionsContext';

function App() {
  return (
    <AuthProvider>
      <PermissionsProvider>
        <DebugProvider>
          <DebugAxiosInterceptor>
            <ThemeProvider theme={Theme}>
            <PatientProvider>
          <CarePlanProvider>
            <PatientAssignmentProvider>
              <PatientMapProvider>
                <LocationProvider>
                  <ObservationProvider>
                    <IACarePlanProvider>
                      <CareGapProvider>
                        <NoRecentVisitProvider>
                          <PCPChangesProvider>
                            <CodingOpportunitiesProvider>
                              <WelcomeCampaignProvider>
                                <AdvancedMdProvider>
                                  <CodingOpProvider>
                                    <InfoPat2Provider>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Router>
                                          <SessionManager>
                                            <AppRouter />
                                          </SessionManager>
                                        </Router>
                                      </LocalizationProvider>
                                    </InfoPat2Provider>
                                  </CodingOpProvider>
                                </AdvancedMdProvider>
                              </WelcomeCampaignProvider>
                            </CodingOpportunitiesProvider>
                          </PCPChangesProvider>
                        </NoRecentVisitProvider>
                      </CareGapProvider>
                    </IACarePlanProvider>
                  </ObservationProvider>
                </LocationProvider>
              </PatientMapProvider>
            </PatientAssignmentProvider>
          </CarePlanProvider>
          </PatientProvider>
        </ThemeProvider>
        </DebugAxiosInterceptor>
      </DebugProvider>
    </PermissionsProvider>
  </AuthProvider>
  );
}

export default App;
